import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useContext } from "react";
import { appContext } from "../../../context/AppContext";
import { AccountList, getAccountList } from "../services/getAccountList";

export function useAccountListQuery(): UseQueryResult<AccountList, AxiosError> {
  const context = useContext(appContext);
  return useQuery({
    queryKey: ["accountList"],
    queryFn: async () => getAccountList(context.getAccessToken),
    keepPreviousData: true,
  });
}
